export default {
  setAllAttributes ({ state, commit }, data) {
    commit('setAllAttributes', data)
  },
  setRelatedAttributeData ({ commit }, payload) {
    commit('setRelatedAttributeData', payload)
  },
  setAttributesActive ({ commit }, payload) {
    commit('setAttributesActive', payload)
  },
  setListingAttributeGroupCombos ({ commit }, payload) {
    commit('setListingAttributeGroupCombos', payload)
  },
  setAttributeFilterQueryStringVar ({ commit }, payload) {
    commit('setAttributeFilterQueryStringVar', payload)
  },
  setActiveAttributeFilters ({ commit }, payload) {
    commit('setActiveAttributeFilters', payload)
  },
  setAttributeRecordsUsed ({ commit }, payload) {
    commit('setAttributeRecordsUsed', payload)
  },
  setProductAttributeInfoData ({ commit }, payload) {
    commit('setProductAttributeInfoData', payload)
  },
  setAttributeMergeDuplicateValuesByName ({ commit }, payload) {
    commit('setAttributeMergeDuplicateValuesByName', payload)
  }
}
